import React, {useEffect, useState} from 'react';

import {EventCard} from "../../../components";

import './appEventsList.scss';
import {useGetEvents} from "../../../operations/queries/useGetEvents";
import {EventsType} from 'models';
import {formatTime} from 'util/formatTime';
import {escapeHtml, removeHtml} from 'util/removeHtmlFromString';

const AppEventsList = () => {
    const {data} = useGetEvents();

    const [events, setEvents] = useState<Array<EventsType>>([])

    useEffect(() => {
        if (!data) return
        let eventList: Array<EventsType> = [];
        console.log({data})
        data?.forEach((eventData: any) => {
            const eventDataAttributes = eventData.attributes
            eventList.push({
                id: eventData.id,
                date: eventDataAttributes.date?.split("T")[0],
                time: formatTime(eventDataAttributes.date?.split("T")[1].split(".")[0]),
                venue: eventDataAttributes.venue,
                address: eventDataAttributes.venue.address,
                image: process.env.REACT_APP_BASE_URL + eventDataAttributes.image.data.attributes.url,
                title: escapeHtml(eventDataAttributes.title),
                description: removeHtml(eventDataAttributes.description),
                category: eventDataAttributes?.categories?.data.map((category: any) => category?.name)
            })
        })
        setEvents(eventList)
    }, [data]);
    return (
        <div className={'app-events'}>
            <div className={'app-events_wrapper max'}>
                <h1 id={'heading'}>Upcoming Business Events</h1>
                <div className={'app-events_wrapper_list'}>
                    {events.map(({id, title, image, description, date}, index) => (
                        <EventCard
                            key={index + title}
                            id={id}
                            title={title}
                            image={image}
                            description={description}
                            date={date}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AppEventsList;
